import { render } from "./Parc.vue?vue&type=template&id=20ee74be&scoped=true&lang=true"
import script from "./Parc.vue?vue&type=script&lang=js"
export * from "./Parc.vue?vue&type=script&lang=js"

import "./Parc.css?vue&type=style&index=0&id=20ee74be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ee74be"]])

export default __exports__